(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsStatementPropertySearch', ['$http', 'Api', function ($http, Api) {
    return {
      scope: {
        model: "=",
        onChange: '&'
      },
      templateUrl: "modules/common/directives/statement-property-search/statement-property-search.html",
      link: function link($scope, element) {
        if ($scope.model.statementProperty) {
          $scope.property = $scope.model.statementProperty;
        }
        $scope.propertySelected = function (property) {
          $scope.model.statementProperty = property;
          $scope.onChange();
        };
        $scope.statementPropertyTypeahead = function (query) {
          if (!query || !query.length) {
            return;
          }
          return $http.get(Api.url('/search/statement-properties'), {
            params: {
              searchTerm: query
            }
          }).then(function activitySearchSuccess(response) {
            return _.pluck(response.data.results, "fieldName");
          });
        };

        // Also consider a property 'selected' if typed in and then clicked away from
        element.children("input").blur($scope.$apply.bind($scope, function () {
          $scope.propertySelected($scope.property);
        }));
      }
    };
  }]);
})();
